import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    ZoneCreate,
    ZoneDto,
    ZoneRead,
    ZoneSearchParams,
} from '../../entities/zone.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';
import { withWarehouseSearchFilter } from '../wms-mapping.util';

const symbols = entitySymbols(PFWmsEntities.Zone);

withDefaultEntityMetadata<ZoneDto>(symbols.dto, {
    locationIdentifiers: [Object],
    zonePriority: Number,
    name: String,
    description: String,
    barcode: String,
    warehouseId: String,
    warehouse: Object,
    resourceAuth: ResourceAuthSymbol,
    customFields: CustomFieldMetadataMap.symbols.dto,
    slots: [Object],
});

withDefaultEntityMetadata<ZoneRead>(symbols.entity, {
    name: String,
    description: String,
    barcode: String,
    warehouseId: String,
    resourceAuth: ResourceAuthSymbol,
    customFields: CustomFieldMetadataMap.symbols.entity,
    zonePriority: Number,
    locationIdentifiers: [Object],
    slots: [Object],
    warehouse: Object,
    zoneType: String,
});

withMetadata<ZoneCreate>(symbols.createBody, {
    name: String,
    description: String,
    barcode: String,
    warehouseId: String,
    resourceAuth: ResourceAuthSymbol,
    zonePriority: Number,
    locationIdentifiers: [Object],
    zoneType: String,
});

withDefaultSearchParamsMetadata<ZoneSearchParams>(symbols.searchParams, {
    name: String,
    warehouseId: String,
    barcode: String,
});

export const ZoneMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<ZoneRead, ZoneDto>(mapper, symbols.entity, symbols.dto);
        createMap<ZoneDto, ZoneRead>(mapper, symbols.dto, symbols.entity);
        createMap<ZoneDto, ZoneCreate>(mapper, symbols.dto, symbols.createBody);
        createMap<IQueryParams<ZoneDto>, ZoneSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('name'),
            withSearchFilter('barcode'),
            withWarehouseSearchFilter(),
            ...withDefaultSearchParamsMappingConfiguration()
        );

        CustomFieldMetadataMap.profile(mapper);
    },
};
